export default __webpack_public_path__ + "static/bg-home.901ba482-b41c9467642a0121c0569f0486930403.jpg";